export default __webpack_public_path__ + "static/media/308.cc80146c.png";